module.exports = __webpack_public_path__ + "img/bandui.d9987454.png";